import { useQuery } from '@tanstack/react-query';
import { getProviderActivePatients } from '@uplift/api';
import { providerQueryKeys } from './providerQueryKeys';


export const useProviderActivePatientsQuery = (providerId: string) => {
  return useQuery({
    queryKey: providerQueryKeys.activePatients(providerId),
    queryFn: async () => {
      const response = await getProviderActivePatients(providerId);

      return response.data;
    }
  });
};
